import React from "react";

import MainLayout from "@components/layouts/MainLayouts/MainLayouts";

import Hero from "./sections/Hero/Hero";
import ProductFeatures from "./sections/ProductFeatures/ProductFeatures";
import SystemSkeyTix from "./sections/SystemSkeyTix/SystemSkeyTix";
import SystemAdvantages from "./sections/SystemAdvantages/SystemAdvantages";
import ApiIntegration from "./sections/ApiIntegration/ApiIntegration";
import SkeyPoap from "./sections/SkeyPoap/SkeyPoap";

import "./LandingPage.scss";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero />
      <ProductFeatures />
      <SystemSkeyTix />
      <SystemAdvantages />
      <ApiIntegration />
      <SkeyPoap />
    </div>
  );
};

export default (
  <MainLayout>
    <LandingPage />
  </MainLayout>
);
